import { render, staticRenderFns } from "./PageListLarge.vue?vue&type=template&id=7754384d"
import script from "./PageListLarge.vue?vue&type=script&lang=js"
export * from "./PageListLarge.vue?vue&type=script&lang=js"
import style0 from "./PageListLarge.vue?vue&type=style&index=0&id=7754384d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports